<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">发布任务</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <!-- <el-form-item label="关联消息" prop="taskId">
          <el-select v-model="ruleform.taskId">
            <el-option
              v-for="item in msgList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="关联消息" v-if="isRelateMsg">
          <div class="textover" :style="inlineItemStyle80">
            {{ messageDetail.entityTypeTranslated }}：{{
              messageDetail.messageIntro
            }}
          </div>
        </el-form-item>
        <el-form-item label="接收人" prop="receiveUser" ref="userRef">
          <el-cascader
            :style="inlineItemStyle25"
            ref="cascader"
            :placeholder="placeholder"
            v-if="cascaderShow"
            :props="ReceiverProps"
            :options="userOptions"
            v-model="ruleform.receiveUser"
            @blur="setPlaceInputValue"
            collapse-tags
            clearable
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="任务标题" prop="title">
          <el-input
            :style="inlineItemStyle80"
            v-model="ruleform.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务内容" prop="taskContent">
          <el-input
            :style="inlineItemStyle80"
            type="textarea"
            rows="2"
            v-model="ruleform.taskContent"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务坐标">
          <el-input
            :style="inlineItemStyle25"
            v-model="ruleform.longitude"
          ></el-input>
          <el-input
            :style="inlineItemStyle25"
            v-model="ruleform.latitude"
          ></el-input>
          <ZjLngLatSelect
            class="newtaskposition"
            :point_lat="ruleform.latitude"
            :point_lng="ruleform.longitude"
            @onGotLngLat="onGotLngLat"
          ></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="任务地址" prop="address">
          <el-input
            :style="inlineItemStyle50"
            v-model="ruleform.address"
          ></el-input>
        </el-form-item>
        <el-form-item label="截止时间" prop="endTime">
          <el-date-picker
            :style="inlineItemStyle25"
            type="datetime"
            style="width: 100%"
            placeholder="选择日期"
            v-model="ruleform.endTime"
            format="yyyy-MM-dd HH:mm"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm"
          ></el-date-picker>
        </el-form-item>
      </zj-layout-container>
      <zj-layout-footer class="footer">
        <el-form-item class="btns">
          <el-button @click="onBack()">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleform')"
            >发 布</el-button
          >
        </el-form-item>
      </zj-layout-footer>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../app";
import Constant from "../config/constant";
import UserTree from "./UserTree";
import UserTabControl from "../../../../../emergency/src/views/src/Plan/UserTabControl";
import MyApis from "@/api";
import { mapGetters, mapActions } from "vuex";
import utils from "@/utils";
import { deptTreeData, listDept } from "@/api/system/permission/dept";
import { listUser } from "@/api/system/permission/user";
import { process } from "@/api/src/message";
import {
  listIntegratedTask,
  getIntegratedTaskById,
  addIntegratedTask,
  updateIntegratedTask,
} from "@/api/src/integratedTask";
import waitAll from "@/utils/src/waitAll";
export default {
  name: "NewTaskHome",
  componentName: "NewTaskHome",
  components: {
    UserTree,
    UserTabControl,
  },
  props: {
    receiverName: {
      type: String,
      default: "",
    },
    receiverId: {
      type: String,
      default: "",
    },

    isLookDetails: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Object,
      default: function () {
        return [];
      },
    },
    messageDetail: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    receiverName(newVal) {
      this.ruleform.receiveUser = newVal; //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
      this.setPlaceInputValue();
    },
    isLookDetails: function (val) {
      if (val) {
        this.getTaskDetails();
      }
    },
    messageDetail(val) {
      if (val && val.id) {
        this.isRelateMsg = true;
      } else {
        this.isRelateMsg = false;
      }
    },
  },
  data() {
    return {
      inlineItemStyle25: {
        width: "25%",
        "margin-right": "2rem",
      },
      inlineItemStyle50: {
        width: "50%",
        "margin-right": "2rem",
      },
      inlineItemStyle80: {
        width: "80%",
        "margin-right": "2rem",
      },
      isshow: true,

      ReceiverProps: {
        value: "id",
        label: "label",

        multiple: true,
      },

      ruleform: {
        // taskId: undefined,
        receiveUser: null,
        title: null,
        taskContent: null,
        messageId: null,
        status: Constant.TaskStatus.Processing.code,
        address: null,
        longitude: 0,
        latitude: 0,
        endTime: null,
      },
      rules: {
        // taskId: [{ require: true, message: "请选择关联消息", trigger: "change" }],
        title: [{ required: true, message: "请填写任务名称", trigger: "blur" }],
        taskContent: [
          { required: true, message: "请填写任务内容", trigger: "blur" },
          {
            min: 0,
            max: 1000,
            message: "长度最长为1000个字符",
            trigger: "blur",
          },
        ],
        receiveUser: [
          { required: true, message: "请选择任务接收人", trigger: "change" },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          var date = new Date();
          date.setFullYear(date.getFullYear() + 2);
          date.setDate(date.getDate() - 1);
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() > date.getTime()
          );
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })(),
      },
      msgkey: "",
      currenttaskvalue: "",
      positionvalue: "",
      startTaskMsgKey: "MessageKey_TaskCenterStartTask",
      userTreeIds: {},
      taskPageUrl: "/m/emg/MobileTaskCenter",
      cascaderShow: true,
      placeholder: "请选择",
      msgList: null,
      isRelateMsg: false, //是否从消息那带过来的
      form: {},
      userOptions: [],
      checkedUserIds: [],
      userList: [],
    };
  },
  created() {
    // if(this.isLookDetails){
    //   this.getTaskDetails();
    // }
  },
  mounted() {
    const that = this;
    that.ruleform.receiveUser = this.receiverName;
    // that.cascaderShow = false;

    this.setPlaceInputValue();
    // this.getMessageList();
    if (this.messageDetail?.id) {
      this.form = this.messageDetail;
      this.isRelateMsg = true;
    } else {
      this.isRelateMsg = false;
    }
    this.getAddressbookList();
  },
  methods: {
    setPlaceInputValue() {
      if (this.receiverName) {
        this.placeholder = this.receiverName;
      } else {
        this.placeholder = "请选择";
      }

      // this.$refs.cascader.inputValue = this.receiverName;
      // this.$refs.cascader.presentText = this.receiverName;
    },
    getAddressbookList() {
      const that = this;
      listDept({}).then((response) => {
        let organizations = response.data;
        listUser({
          pageNum: 1,
          pageSize: 10000,

          status: 0,
        }).then((res) => {
          if (res.rows) {
            that.userList = res.rows;
            organizations.map((item) => {
              item.id = item.deptId;
              item.label = item.deptName;

              res.rows.map((p) => {
                if (p.deptId == item.deptId) {
                  p.parentId = item.deptId;
                  p.id = p.userId;
                  p.label = p.userName;
                }
              });
            });
            let arr = [...organizations, ...res.rows];
            this.userOptions = that.arrayToTree(arr, "0");
          }
        });
      });
    },
    // 扁平数组转树形结构
    arrayToTree(arr, id) {
      const temp = [];
      for (const item of arr) {
        if (item.parentId == id) {
          temp.push({ ...item, children: this.arrayToTree(arr, item.id) });
        }
      }
      if (temp.length > 0) {
        return temp;
      }
    },

    loadNode(node, resolve) {
      if (node.level === 0) {
        this.getTreeselect(resolve);
      } else {
        this.initUser(node.data.id, resolve);
      }

      // if (
      //   node.level > 0 &&
      //   node.data &&
      //   node.data.children &&
      //   node.data.children.length > 0
      // ) {
      //   return resolve(node.data.children);
      // } else if (node.level > 0 && node.data) {
      //   this.initUser(node.data.id, resolve);
      // }
    },
    // 查询部门下拉树结构
    getTreeselect(resolve) {
      deptTreeData().then((response) => {
        const nodes = response.data;

        resolve(nodes);
      });
    },
    // 获取用户
    initUser(deptId, resolve) {
      this.loading = true;
      listUser({
        pageNum: 1,
        pageSize: 999,

        status: 0,

        deptId: deptId,
      }).then((response) => {
        const nodes = [];
        if (response.rows) {
          response.rows.forEach((item) => {
            nodes.push({
              label: item.userName,
              id: item.userId,
              leaf: true,
              data: item,
              children: [],
              type: "user",
            });
          });
        }
        this.loading = false;

        resolve(nodes);
      });
    },
    submitForm(formName) {
      let that = this;
      const checkedNodes = this.$refs.cascader.getCheckedNodes();
      this.checkedUserIds = [];
      if (checkedNodes && checkedNodes.length > 0) {
        checkedNodes.forEach((ele) => {
          if (ele.data?.userId) {
            this.checkedUserIds.push(ele.data.userId);
          }
        });
      } else if (that.receiverId) {
        this.checkedUserIds.push(that.receiverId);
      }
      let mapU = {};
      let checkdUsers = [],
        usernames = [];
      this.checkedUserIds.forEach((item) => {
        mapU[item] = item;
      });
      this.userList.forEach((item) => {
        if (mapU[item.userId]) {
          checkdUsers.push(item);
          usernames.push(item.userName);
        }
      });
      if (that.receiverName || that.ruleform.receiveUser.length > 0) {
        that.$nextTick(() => {
          that.$refs.ruleform.clearValidate("receiveUser");
          // that.$refs["ruleform"].clearValidate(["receiveUser"]);
          // that.$refs.userRef.clearValidate();
        });
      }
      this.$refs[formName].validate().then((valid) => {
        if (valid) {
          if (usernames.length > 0) {
            that.ruleform.receiveUser = usernames.join(",");
          }
          addIntegratedTask(this.ruleform).then((response) => {
            that.$emit("newtaskcreated");
            // this.$message({
            //   type: "success",
            //   message: "任务发送成功!",
            // });
            this.$emit("handlerclose");
            this.logInfo.ActionName = "发布任务";
            this.logInfo.LogMessage = "任务发布成功";
            this.logInfo.ModuleName = "任务";
            this.logInfo.PageName = "首页-任务";
            this.addOperationLog();
            if (response.data) {
              that.sendMsg(response.data, checkdUsers);
              //如果关联消息，则处理消息
              if (that.isRelateMsg) {
                that.processMsg(response.data);
              }
            } else {
              that.$message({
                type: "error",
                message: "任务发送失败!",
              });
            }
          });
        }
      });
    },
    sendMsg(taskid, checkdUsers) {
      return new Promise((resolve, reject) => {
        var arr = [];
        checkdUsers.forEach((item) => {
          arr.push(this.sendSms(item.phonenumber, taskid));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
            this.$message({
              type: "success",
              message: "任务发送成功!",
            });
            this.$emit("handlerclose");
          })
          .catch((e) => {
            reject(e);
            this.$message({
              type: "error",
              message: "任务发送失败!",
            });
            this.$emit("handlerclose");
          });
      });
    },
    sendSms(phonenumber, taskid) {
      const url =
        this.CNF("api.taskUrl") + this.taskPageUrl + "?ExecutTaskId=" + taskid;
      const content =
        "您有一个任务：" +
        this.ruleform.title +
        ",任务内容:" +
        this.ruleform.taskContent +
        ",任务地址与任务反馈请点击此链接：" +
        url;
      return new MyApis.SendSmsApi()
        .SendSms({
          // Id: 1,
          Id: ZJApp.ZJUtils.uuid(),
          PhoneNo: phonenumber,
          Content: content,
          Charset: "GBK",
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          SendTime: new Date(),
        })
        .then((r) => {
          r = r.data.Data;

          this.loading = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    addContact() {
      this.ruleform.PhoneList.push({ Phone: "" });
    },
    removeContact(index) {
      if (this.ruleform.PhoneList.length > 1) {
        this.ruleform.PhoneList.splice(index, 1);
      }
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    getOrgId: function () {
      let deptId =
        ZJApp.ZJUser.current.Departments.length > 0
          ? ZJApp.ZJUser.current.Departments[0].OrgId
          : "error-no-department";
      return deptId;
    },
    onGotLngLat(obj) {
      this.ruleform.latitude = obj.lat || 0;
      this.ruleform.longitude = obj.lng || 0;
      if (this.ruleform.longitude && this.ruleform.latitude) {
        this.getAddress(this.ruleform.longitude, this.ruleform.latitude);
      }
    },
    //根据经纬度反解析地址
    getAddress(Longitude, Latitude) {
      const that = this;
      // 创建地理编码实例, 并配置参数获取乡镇级数据
      var myGeo = new BMap.Geocoder({ extensions_town: true });
      // 根据坐标得到地址描述
      myGeo.getLocation(new BMap.Point(Longitude, Latitude), function (result) {
        if (result) {
          that.ruleform.address = result.address;
        }
      });
    },
    getUserIds() {
      let userids = [];
      var chil = this.$refs["userTabls"];
      if (chil && chil.GetOrgUserIds) {
        userids = chil.GetOrgUserIds();
      }
      return userids;
    },
    getNewTask() {
      var task = this.ruleform;

      // var userids = this.getUserIds();
      var userids = [];
      Object.keys(this.userTreeIds).map((item) => {
        userids = userids.concat(this.userTreeIds[item]);
      });
      console.log(userids, "0000");
      // if(userids.length == 0 && this.ruleform.PhoneList.length == 0){
      //   that.$message({
      //     message:'联系电话不能为空！',
      //     type: "error"
      //   });
      //   return
      // }
      if (userids) {
        for (let i = 0; i < userids.length; i++) {
          if (userids[i]) {
            task.ListReceiver.push({
              Creater: ZJApp.ZJUser.current.UserName,
              //CreateTime :  new Date(),
              Modifier: ZJApp.ZJUser.current.UserName,
              //ModifyTime :  new Date(),
              Validity: 1,
              //Extend1: userids[i],
              OrgId: this.getOrgId(),
              ExecutId: this.ExecutId,
              ExecutReceiverId: ZJApp.ZJUtils.uuid(),
              ReceiverId: userids[i],
            });
          }
        }
      }

      for (let i = 0; i < this.ruleform.PhoneList.length; i++) {
        if (this.ruleform.PhoneList[i].Phone) {
          task.ListReceiver.push({
            Creater: ZJApp.ZJUser.current.UserName,
            //CreateTime :  new Date(),
            Modifier: ZJApp.ZJUser.current.UserName,
            //ModifyTime :  new Date(),
            Validity: 1,
            Extend1: this.ruleform.PhoneList[i].Phone,
            OrgId: this.getOrgId(),
            ExecutId: this.ExecutId,
            ExecutReceiverId: ZJApp.ZJUtils.uuid(),
          });
        }
      }

      return task;
    },
    //消息转为处理

    processMsg(taskid) {
      //已处理
      this.form.status = 1;
      this.form.processResult = "转任务";
      this.form.taskId = taskid;
      //  this.form.uploadResouse = this.fileImgList.join(",");
      process(this.form)
        .then((r) => {
          r = r.code;
          this.logInfo.ActionName = "消息处理转任务";
          this.logInfo.LogMessage = r == 200 ? "消息处理成功" : "消息处理失败";
          this.logInfo.ModuleName = "消息";
          this.logInfo.PageName = "消息-待处理";
          this.addOperationLog();
          this.loading = false;
          this.$emit("handlerclose");
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
  beforeDestroy() {
    // 注销监听事件
    utils.bus.$off(["getIds"]);
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .content > .el-form-item > .el-form-item__label {
    flex: 0 0 auto !important;
  }
}
.textover {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
}
/deep/.el-cascader__tags .el-tag {
  background: #257dd4 !important;
}
</style>